import { configureStore as configureStoreDev } from "./configureStore.dev";
import { configureStore as configureStoreProd } from "./configureStore.prod";

export const configureStore = process.env.NODE_ENV !== "production"
  ? configureStoreDev
  : configureStoreProd;


// WEBPACK FOOTER //
// ./src/store/index.ts